<template lang="pug">
.select-technician
  div
    button.change-button(
      :disabled="disabled || loading"
      title="Entregar a cliente por tienda"
      @click="handleShowModal")
      | Entregar a cliente por tienda
      b-spinner(v-if="loading" class="ml-2" variant="white" small)
    SamtekModal(
      v-model="showModal"
      :title="'Entregar a cliente por tienda'"
      confirmText="Guardar"
      cancelText="Cancelar"
      :loading="loading"
      :disableConfirm="$v.$invalid || loading"
      @shown="onModalShown"
      @hide="onModalHide"
      @confirm="confirmarEntrega"
      @cancel="hideModal"
    )
      b-form-group(label="Nombre cliente")
        b-input(:value="modalData.cliente_nombre" disabled)
      b-form-row
        b-col(cols="6")
          b-form-group(label="Teléfono")
            b-input(:value="modalData.telefono" disabled)
        b-col(cols="6")
          b-form-group(label="Email")
            b-input(:value="modalData.email" disabled)
      b-form-row
        b-col(cols="6")
          b-form-group(label="N° de boleta")
            b-input(:value="modalData.boleta_folio" disabled)
        b-col(cols="6")
          b-form-group(label="Pasarela de pago")
            b-input(:value="`${modalData.pasarela_pago || ''}`" disabled)
        b-col(cols="12")
          b-form-group(label="ID de transacción")
            b-input(:value="`${modalData.codigo_pago ? `${modalData.codigo_pago}` : ''}`" disabled)
      b-form-group(label="Tipo de envío")
        b-form-select(
          v-model="tipo_envio"
          :options="tipoEnvioOptions"
          :state="$v.tipo_envio.$dirty ? !$v.tipo_envio.$invalid : null")
        .errors(v-if="$v.tipo_envio.$dirty")
          b-form-invalid-feedback(:state="$v.tipo_envio.required") Campo requerido
      div(v-if="isDespacho")
        b-form-group(label="Empresa de courier")
          b-form-select(
            v-model="courier"
            :options="optionsCourier"
            :state="$v.courier.$dirty ? !$v.courier.$invalid : null")
          .errors(v-if="$v.courier.$dirty")
            b-form-invalid-feedback(:state="$v.courier.required") Campo requerido
        b-form-row
          b-col(cols="12")
            b-form-group(label="N° de courier")
              b-input(v-model="numero_courrier" :state="$v.$dirty ? !$v.numero_courrier.$invalid : null")
              .errors(v-if="$v.numero_courrier.$dirty")
                b-form-invalid-feedback(:state="$v.numero_courrier.required") Campo requerido
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  components: {
    SamtekModal: () => import('@/components/Common/SamtekModal.vue'),
  },
  name: 'ActionEntregarClienteTienda',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled', 'toast'],
  validations: {
    tipo_envio: { required: (v) => !!v },
    courier: {
      required: requiredIf(function () {
        return this.isDespacho
      }),
    },
    numero_courrier: {
      required: requiredIf(function () {
        return this.isDespacho
      }),
    },
  },
  data() {
    return {
      showModal: false,
      modalData: {
        cliente_nombre: '',
        telefono: '',
        email: '',
        boleta_folio: '',
        pasarela_pago: '',
        codigo_pago: '',
      },
      tipo_envio: null,
      courier: null,
      numero_courrier: '',
      numero_guia_despacho: '',
    }
  },
  computed: {
    ...mapGetters('OTStore', ['couriers']),
    tipoEnvioOptions() {
      return [
        { value: null, text: 'Seleccionar...' },
        { value: 'RETIRO', text: 'Retiro por cliente' },
        { value: 'DESPACHO', text: 'Despacho' },
      ]
    },
    optionsCourier() {
      const opts = this.couriers.map((c) => ({ value: c.id, text: c.nombre }))
      return [{ value: null, text: 'Seleccione...' }, ...opts]
    },
    isDespacho() {
      return this.tipo_envio === 'DESPACHO'
    },
  },
  methods: {
    ...mapActions('OTStore', [
      'entregaTiendaDatos',
      'entregaTiendaConfirmar',
      'getCourier',
    ]),
    handleShowModal() {
      this.startLoading()
      this.showModal = true
      this.cargarDatos()
    },
    async cargarDatos() {
      try {
        await this.getCourier()
        const resp = await this.entregaTiendaDatos(this.ot.ot)
        if (resp.status === 200) {
          this.modalData = resp.data || {}
          this.tipo_envio = resp.data?.tipo_envio || null
          if (this.isDespacho && resp.data?.courier_sugerido) {
            const sugerido = this.couriers.find(
              (c) =>
                (c.nombre || '').toLowerCase() ===
                (resp.data.courier_sugerido || '').toLowerCase()
            )
            this.courier = sugerido ? sugerido.id : null
          }
        } else {
          this.toast(resp.data || 'No se pudo obtener datos de tienda', {
            variant: 'danger',
          })
          this.showModal = false
        }
      } catch (e) {
        console.error(e)
        this.toast('Error al cargar datos de tienda', { variant: 'danger' })
        this.showModal = false
      } finally {
        this.stopLoading()
      }
    },
    onModalShown() {
      this.stopLoading()
    },
    onModalHide() {
      this.stopLoading()
    },
    hideModal() {
      this.showModal = false
    },
    async confirmarEntrega() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      try {
        await this.executeWithLoading(
          async () => {
            const payload = {
              otId: this.ot.ot,
              tipo_envio: this.tipo_envio,
              courier: this.courier,
              numero_courrier: this.numero_courrier,
            }
            const resp = await this.entregaTiendaConfirmar(payload)
            if (resp.status === 200) {
              this.toast('Entrega registrada correctamente', {
                variant: 'success',
              })
              this.hideModal()
              this.$emit('changed')
              this.$router.push(`/orden/${this.ot.ot}`)
            } else {
              this.toast(resp.data || 'No se pudo confirmar la entrega', {
                variant: 'danger',
              })
            }
          },
          { delay: 400 }
        )
      } catch (e) {
        console.error(e)
        this.toast('Error al confirmar entrega', { variant: 'danger' })
      }
    },
  },
}
</script>
